export const MobileDownloadModal = ({
  currentIndex,
  totalPhotos,
  onDownload,
  onCancel,
}: {
  currentIndex: number;
  totalPhotos: number;
  onDownload: () => void;
  onCancel: () => void;
}) => {
  const isLast = currentIndex === totalPhotos - 1;
  return (
    <div style={mobileDownloadModalStyles.overlay}>
      <div style={mobileDownloadModalStyles.modal}>
        <div style={mobileDownloadModalStyles.title}>
          Download Photo {currentIndex + 1} of {totalPhotos}
        </div>
        <div style={mobileDownloadModalStyles.subtitle}>
          Tap download to save this photo to your device
        </div>
        <div style={mobileDownloadModalStyles.buttonContainer}>
          <button style={mobileDownloadModalStyles.cancelButton} onClick={onCancel}>
            Cancel
          </button>
          <button style={mobileDownloadModalStyles.downloadButton} onClick={onDownload}>
            {isLast ? "Download" : "Download & Next"}
          </button>
        </div>
      </div>
    </div>
  );
};

const mobileDownloadModalStyles = {
  overlay: {
    position: "fixed" as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "24px",
    margin: "16px",
    maxWidth: "320px",
    width: "100%",
    textAlign: "center" as const,
  },
  title: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#0d2137",
    marginBottom: "8px",
  },
  subtitle: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "24px",
  },
  buttonContainer: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
  },
  downloadButton: {
    backgroundColor: "#1e88e5",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "12px 24px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    flex: 1,
  },
  cancelButton: {
    backgroundColor: "#fff",
    color: "#666",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: "12px 24px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    flex: 1,
  },
};
